import { render } from "./DemoSettingsDialog.vue?vue&type=template&id=bfa69d82&scoped=true"
import script from "./DemoSettingsDialog.vue?vue&type=script&lang=ts"
export * from "./DemoSettingsDialog.vue?vue&type=script&lang=ts"

import "./DemoSettingsDialog.vue?vue&type=style&index=0&id=bfa69d82&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bfa69d82"

export default script